/**
 * Header Mobile Menu Toggle
 *
 * Handles opening and closing the mobile menu in the header.
 */
(function() {
	const mobileMenuToggle = document.querySelector('.header__mobile-menu-toggle');
	const mobileMenuClose = document.querySelector('.header__mobile-menu-close');
	const mobileMenu = document.querySelector('.header__mobile-menu');
	const body = document.body;

	// Return early if elements don't exist.
	if (!mobileMenuToggle || !mobileMenu || !mobileMenuClose) {
		return;
	}

	/**
	 * Open mobile menu
	 */
	function openMobileMenu() {
		mobileMenu.classList.add('is-open');
		mobileMenuToggle.setAttribute('aria-expanded', 'true');
		body.style.overflow = 'hidden'; // Prevent body scroll when menu is open
	}

	/**
	 * Close mobile menu
	 */
	function closeMobileMenu() {
		mobileMenu.classList.remove('is-open');
		mobileMenuToggle.setAttribute('aria-expanded', 'false');
		body.style.overflow = ''; // Restore body scroll
	}

	// Toggle menu when open button is clicked
	mobileMenuToggle.addEventListener('click', function(e) {
		e.preventDefault();
		openMobileMenu();
	});

	// Close menu when close button is clicked
	mobileMenuClose.addEventListener('click', function(e) {
		e.preventDefault();
		closeMobileMenu();
	});

	// Close menu when a link inside the menu is clicked
	mobileMenu.addEventListener('click', function(event) {
		const link = event.target.closest('a[href]');
		if (!link) {
			return;
		}
		const href = link.getAttribute('href');
		if (link.hasAttribute('data-get-in-touch-modal') || (href && href !== '#')) {
			closeMobileMenu();
		}
	});

	// Close menu when clicking outside
	document.addEventListener('click', function(event) {
		const isClickInsideMenu = mobileMenu.contains(event.target);
		const isClickOnToggle = mobileMenuToggle.contains(event.target);

		if (!isClickInsideMenu && !isClickOnToggle && mobileMenu.classList.contains('is-open')) {
			closeMobileMenu();
		}
	});

	// Close menu on escape key
	document.addEventListener('keydown', function(event) {
		if (event.key === 'Escape' && mobileMenu.classList.contains('is-open')) {
			closeMobileMenu();
		}
	});
})();

/**
 * Header Scroll Effect
 *
 * Adds dark blur background to header when scrolling down.
 */
(function() {
	const header = document.querySelector('.header');
	const scrollThreshold = 50; // Pixels to scroll before adding background

	// Return early if header doesn't exist.
	if (!header) {
		return;
	}

	/**
	 * Handle scroll event
	 */
	function handleScroll() {
		const scrollY = window.scrollY || window.pageYOffset;

		if (scrollY > scrollThreshold) {
			header.classList.add('is-scrolled');
		} else {
			header.classList.remove('is-scrolled');
		}
	}

	// Check initial scroll position (for when page loads scrolled)
	handleScroll();

	// Throttle scroll event for better performance
	let ticking = false;
	window.addEventListener('scroll', function() {
		if (!ticking) {
			window.requestAnimationFrame(function() {
				handleScroll();
				ticking = false;
			});
			ticking = true;
		}
	}, { passive: true });
})();
